import React, { useEffect } from "react";
import {
  FooterContainer,
  FooterContent,
  FooterLogo,
  LogoText,
  SocialLinks,
  SocialIcon,
  Copyright,
} from "../styles/components/FooterStyles";

function Footer() {
  useEffect(() => {
    const copyright = document.querySelector(".copyright-text");
    if (copyright) {
      copyright.style.opacity = "1";
      copyright.style.transform = "perspective(1200px) translateY(0)";
    }
  }, []);

  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>
          <LogoText>TITANS TAP</LogoText>
        </FooterLogo>
        <SocialLinks>
          <SocialIcon
            href="https://t.me/titanstapio"
            target="_blank"
            rel="noopener"
            style={{
              backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 41"><path d="M 11.909 23.166 L 7.203 21.357 C 6.624 20.633 7.444 19.969 7.927 19.728 L 29.645 10.678 C 31.672 9.955 32.059 11.583 31.998 12.488 L 29.102 30.044 C 28.813 31.637 26.93 31.552 26.026 31.311 L 18.424 25.881 C 17.121 25.157 17.881 24.011 18.424 23.528 L 25.283 16.652 C 26.17 15.204 25.06 15.746 24.216 16.289 C 21.923 17.797 16.976 21.103 15.528 22.262 C 14.081 23.42 12.512 23.348 11.909 23.166 Z" fill="rgb(0, 0, 0)"></path></svg>')`,
            }}
            aria-label="Telegram"
          />
          <SocialIcon
            href="https://x.com/Titan_s_Tap"
            target="_blank"
            rel="noopener"
            style={{
              backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 41"><path d="M 10.391 10.146 L 16.446 10.146 L 21.697 17.863 L 28.342 10.146 L 30.217 10.146 L 22.608 19.041 L 30.914 31.205 L 24.698 31.205 L 19.179 23.006 L 12.159 31.205 L 10.23 31.205 L 18.322 21.881 Z M 12.965 11.593 L 15.751 11.593 L 28.343 29.919 L 25.503 29.919 Z" fill="rgb(0, 0, 0)"></path></svg>')`,
            }}
            aria-label="Twitter"
          />
          <SocialIcon
            href="https://medium.com/@moojidevelopment"
            target="_blank"
            rel="noopener"
            style={{
              backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 41"><path d="M 23 20.5 C 23 25.471 18.971 29.5 14 29.5 C 9.029 29.5 5 25.471 5 20.5 C 5 15.529 9.029 11.5 14 11.5 C 18.971 11.5 23 15.529 23 20.5 Z M 32.5 20.5 C 32.5 25.194 30.485 29 28 29 C 25.515 29 23.5 25.194 23.5 20.5 C 23.5 15.806 25.515 12 28 12 C 30.485 12 32.5 15.806 32.5 20.5 Z M 34.5 28 C 35.328 28 36 24.642 36 20.5 C 36 16.358 35.328 13 34.5 13 C 33.672 13 33 16.358 33 20.5 C 33 24.642 33.672 28 34.5 28 Z" fill="rgb(0, 0, 0)"></path></svg>')`,
            }}
            aria-label="Medium"
          />
        </SocialLinks>
        <Copyright className="copyright-text">
          ⓒ 2025. Titan's Tap. All rights reserved.
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;
